<!--  -->
<template>
  <div class="myplan-todo-box">
    <div v-if="planCurrentPhases">
      <div class="myplan-todo-progress-box" v-if="planCurrentPhases.sum">
          <div class="myplan-todo-progress-box-title">{{planCurrentPhases.name}}</div>
          <div>
            <myplan-todo-progress :strokeColor="strokeColor" :sum="planCurrentPhases.sum" :finishCount="Number(planCurrentPhases.finishCount)"></myplan-todo-progress>
          </div>
      </div>
      <div class="myplan-collapse-box">
          <Collapse accordion v-model="collapseMiddleActiveName" class="inner-collapse">
              <Panel :name="targetScoreItem.name" v-for="(targetScoreItem,targetScoreIndex) in planCurrentPhases.scoreInfos" :key="targetScoreIndex+'SCORE'">
                  <div class="myplan-collapse-big-title" >
                    <div class="title-main">
                    <Row>
                      <Col :span="12"><span class="title-main-left">{{targetScoreItem.name}}</span></Col>
                      <Col :span="10"><span style="padding-left: 10px;">{{targetScoreItem.phasesName}}</span></Col>
                      <Col :span="2"><span class='title-main-right'>{{targetScoreItem.finishCount}}/{{targetScoreItem.sum}}</span></Col>
                    </Row>
                    </div>
                    <div class="title-pad-left attention" @click.stop>
                      <div class="attention-main">
                          <span class="attention-icon"><Icon type="ios-information-circle-outline" /></span>
                          <div class="attention-box" >
                            <span class="attention-title-noce">注意事项：</span>
                            <div :class="targetScoreItem.actionType?'more-hide':'more-show'">
                              <pre  :ref="'showHeightScore'+targetScoreIndex">{{targetScoreItem.desc?targetScoreItem.desc:'--'}}</pre>
                              <div class="change-more-less" @click="targetScoreItem.actionType = !targetScoreItem.actionType" v-show="targetScoreItem.showHeightScore>24">
                                <span>{{ targetScoreItem.actionType?'':'收起'}}</span>
                                <span :class="[targetScoreItem.actionType?'':'less-icon']" class="icon-more-btn"><Icon type="ios-arrow-up" v-show="!targetScoreItem.actionType" /></span>
                              </div>
                            </div>
                            <div class="change-more-less" @click="targetScoreItem.actionType = !targetScoreItem.actionType" v-show="targetScoreItem.showHeightScore>24">
                                <span>{{ targetScoreItem.actionType?'展开更多':''}}</span>
                                <span :class="[targetScoreItem.actionType?'more-icon':'']" class="icon-more-btn"><Icon type="ios-arrow-down" v-show="targetScoreItem.actionType" /></span>
                              </div>
                          </div>
                      </div>
                    </div>
                  </div>
                  <div slot="content">
                    <div class="myplan-collapse-content" @click.stop>
                      <div class="myplan-collapse-content-list dis_10"  v-for='(innerScoreItem,innerScoreIndex) in targetScoreItem.todos' :key="'SCORE'+innerScoreIndex">
                        <Row>
                          <Col :span="12">
                            <Checkbox v-model="innerScoreItem.finish"  @on-change="planMenteeFinishTodos(innerScoreItem,innerScoreIndex,'SCORE')" class="checkout-box-icon"></Checkbox>
                            <span :class="{'checkbox-line':innerScoreItem.finish}" class="color_333">{{innerScoreItem.name}}</span>
                          </Col>
                          <Col :span="8">
                            <span>{{innerScoreItem.phasesName}}&nbsp;&nbsp;{{getTime(innerScoreItem.completionTime)}}</span>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
              </Panel>
              <Panel :name="targetItem.name" v-for="(targetItem,targetIndex) in planCurrentPhases.targetInfos" :key="'OTHER'+targetIndex">
                  <div class="myplan-collapse-big-title" >
                    <div class="title-main">
                    <Row>
                      <Col :span="12"><span class="title-main-left">{{targetItem.name}}</span></Col>
                      <Col :span="10"><span style="padding-left: 10px;">{{targetItem.phasesName}}</span></Col>
                      <Col :span="2"><span class='title-main-right'>{{targetItem.finishCount}}/{{targetItem.sum}}</span></Col>
                    </Row>
                    </div>
                    <div class="title-pad-left attention" @click.stop>
                      <div class="attention-main">
                          <span class="attention-icon"><Icon type="ios-information-circle-outline" /></span>
                          <div class="attention-box" >
                            <span class="attention-title-noce">注意事项：</span>
                            <div :class="targetItem.actionType?'more-hide':'more-show'">
                              <pre  :ref="'showHeight'+targetIndex">{{targetItem.desc}}</pre>
                              <div class="change-more-less" @click="targetItem.actionType = !targetItem.actionType" v-show="targetItem.showHeight>24">
                                <span>{{ targetItem.actionType?'':'收起'}}</span>
                                <span :class="[targetItem.actionType?'':'less-icon']" class="icon-more-btn"><Icon type="ios-arrow-up" v-show="!targetItem.actionType" /></span>
                              </div>
                            </div>
                            <div class="change-more-less" @click="targetItem.actionType = !targetItem.actionType" v-show="targetItem.showHeight>24">
                                <span>{{ targetItem.actionType?'展开更多':''}}</span>
                                <span :class="[targetItem.actionType?'more-icon':'']" class="icon-more-btn"><Icon type="ios-arrow-down" v-show="targetItem.actionType" /></span>
                              </div>
                          </div>
                      </div>
                    </div>
                  </div>
                  <div slot="content">
                    <div class="myplan-collapse-content" @click.stop>
                      <div class="myplan-collapse-content-list dis_10"  v-for='(innerItem,innerIndex) in targetItem.todos' :key="'OTHER'+innerIndex">
                        <Row>
                          <Col :span="12">
                            <Checkbox v-model="innerItem.finish"  @on-change="planMenteeFinishTodos(innerItem,innerIndex,'OTHER')" class="checkout-box-icon"></Checkbox>
                            <span :class="{'checkbox-line':innerItem.finish}" class="color_333">{{innerItem.name}}</span>
                          </Col>
                          <Col :span="8">
                            <span>{{innerItem.phasesName}}&nbsp;&nbsp;{{getTime(innerItem.completionTime)}}</span>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
              </Panel>
          </Collapse>
      </div>
    </div>
  </div>
</template>
<script>
import { date2String } from '@/libs/tools'
import MyplanTodoProgress from './myplan-todo-progress'
import { planMenteeCurrentPhases, planMenteeFinishTodos } from '@/api/data-myplan'
export default {
  name: 'myplan-todo-tabs',
  components: {
    MyplanTodoProgress
  },
  data () {
    return {
      // 折叠面板
      collapseMiddleActiveName: '',
      planCurrentPhases: {
      },
      // 横向进度条的颜色
      strokeColor: '#6589dd',
      // 注意事项
      actionType: false,
      showHeight: ''
    }
  },
  computed: {

  },
  mounted () {
    // 当前阶段
    this.planMenteeCurrentPhases()
    this.getDomHeight()
  },
  methods: {
    // 处理时间
    getTime (time) {
      return time ? date2String(time) : ''
    },
    getDomHeight () {
      this.$nextTick(function () {
        if (this.planCurrentPhases) {
          if (this.planCurrentPhases.scoreInfos) {
            this.planCurrentPhases.scoreInfos.forEach((targetScoreItem, targetScoreIndex) => {
              this.$set(targetScoreItem, 'showHeightScore', '')
              this.$set(targetScoreItem, 'actionType', false)
              let getDomScore = this.$refs['showHeightScore' + targetScoreIndex]
              if (getDomScore) {
                targetScoreItem.showHeightScore = getDomScore[0].offsetHeight
                if (targetScoreItem.showHeightScore > 24) {
                  targetScoreItem.actionType = true
                }
              }
            })
          }
          if (this.planCurrentPhases.targetInfos) {
            this.planCurrentPhases.targetInfos.forEach((targetItem, targetIndex) => {
              this.$set(targetItem, 'showHeight', '')
              this.$set(targetItem, 'actionType', false)
              let getDom = this.$refs['showHeight' + targetIndex]
              if (getDom) {
                targetItem.showHeight = getDom[0].offsetHeight
                if (targetItem.showHeight > 24) {
                  targetItem.actionType = true
                }
              }
            })
          }
        }
      })
    },
    planMenteeCurrentPhases () {
      planMenteeCurrentPhases().then(res => {
        if (res.code === 0) {
          this.planCurrentPhases = res.data.info
          this.getDomHeight()
        }
      })
    },
    // 完成todo信息
    planMenteeFinishTodos (item, index, type) {
      let data = {}
      data.id = item.id
      if (type === 'SCORE') {
        data.finish = item.finish
        planMenteeFinishTodos(data).then(res => {
          if (res.code === 0) {
            this.planMenteeCurrentPhases()
            this.$emit('up-data')
          }
        })
      } else {
        data.finish = item.finish
        planMenteeFinishTodos(data).then(res => {
          if (res.code === 0) {
            this.planMenteeCurrentPhases()
            this.$emit('up-data')
          }
        })
      }
    }
  }
}
</script>
<style lang='less'>
// 折叠面板
.myplan-collapse-box{
  //复选框选中样式
  .ivu-checkbox-checked .ivu-checkbox-inner:after{
    border-color:#6589DD;
  }
  .ivu-checkbox-checked .ivu-checkbox-inner{
    border-color:#6589DD;
    background-color: #E9EEF9;
  }
  //折叠面板
  >.ivu-collapse{
    background-color:#fafafc;
    border:none;
  }
   .ivu-icon-ios-arrow-forward:before{
      content: "\F341";
    }
  >.ivu-collapse>.ivu-collapse-item {
    background-color:#fafafc;
    border-top:0;
  }
  >.ivu-collapse>.ivu-collapse-item>.ivu-collapse-header{
    height:auto;
    background-color:none;
    border-bottom:none;
    padding-left:0;
  }
   .ivu-collapse-content {
    background-color:#fafafc;
    >.ivu-collapse-content-box{
      padding:0px 62px;
    }
  }
  .ivu-collapse>.ivu-collapse-item>.ivu-collapse-header>i{
    position: relative;
    top: 46px;
    left: 58px;
    z-index: 2;
    font-size:28px;
    color:#D8D8D8;
  }
  .title-pad-left {
    background-color:#F4F4F4;
    padding-left:32px;
    padding-right:32px;
    margin:10px 62px 10px;
  }
  .myplan-collapse-content{
    margin-left:19px;
    margin-top:10px;
    &-list{
      margin-bottom:10px;
    }
  }
  .myplan-collapse-big-title {
    position: relative;
    z-index: 1;
    display: inline-block;
    width:100%;
  }
  .checkout-box-icon {
    margin-right:12px;
  }
  .checkbox-line{
    text-decoration: line-through;
  }
  .title-main{
    padding:10px 58px;
    background-color: #ffffff;
    &-left{
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      line-height: 28px;
      padding-left:38px;
    }
    &-right{
      font-size:16px;
      display: inline-block;
      width:100%;
      text-align: right;
    }
  }
  .attention{
    .attention-main {
      display: flex;
      color:#999999;
      font-size:14px;
      padding:8px 1px;
      line-height: 22px;
    }
    .attention-box{
      display:flex;
      width:100%;
      padding-left:11px;
      .change-more-less{
        display: inline-block;
        width:110px;
        margin-left:9px;
        color:#6589DD;
        font-size:12px;
        text-decoration: underline;
        cursor: pointer;
      }
    }
    .attention-title-noce {
      display: inline-block;
      width:104px;
      color:#666666;
      font-weight: 600;
    }
    .icon-more-btn {
      display: inline-block;
      width:5px;
      height:5px;
    }
    .more-icon{
      // background-color:red;
    }
    .less-icon{
      // background-color:yellow;
    }
    .more-show {
      display: inline-block;
      width:100%;
      height:auto;
    }
    .more-hide {
      display: inline-block;
      width:100%;
      height:24px;
      overflow: hidden;
    }
  }
}
</style>
<style lang="less" scoped>
// 横向进度条的样式
.myplan-todo-progress-box {
  margin-top:56px;
  margin-bottom:30px;
  background: #FFFFFF;
  padding:24px 179px;
  &-title{
    font-weight: 600;
    font-size:14px;
    padding-bottom:13px;
  }
}
// 折叠三角形
.arrow-right-b {
  display: inline-block;
  width:0;
  height:0;
  border-top:7px solid transparent;
  border-bottom:7px solid transparent;
  border-left:7px solid #D8D8D8;
}
.arrow-down-b {
  display: inline-block;
  width:0;
  height:0;
  border-left:7px solid transparent;
  border-right:7px solid transparent;
  border-top:7px solid #D8D8D8;
}
.color_333{
    color:#333333;
}
.dis_10{
  margin-bottom:10px;
}
</style>
